function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.75 12V2.85l4.2 4.2L12 6 6 0 0 6l1.05 1.05 4.2-4.2V12h1.5z",
  fill: "#D4E1EE"
});

var SvgIconArrowUpWithTailInactive = function SvgIconArrowUpWithTailInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02Ljc1IDEyTDYuNzUgMi44NUwxMC45NSA3LjA1TDEyIDZMNiAwTDAgNkwxLjA1IDcuMDVMNS4yNSAyLjg1TDUuMjUgMTJINi43NVoiIGZpbGw9IiNENEUxRUUiLz4KPC9zdmc+Cg==";
export { SvgIconArrowUpWithTailInactive as ReactComponent };